import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

interface FirmRow {
  id: string;
  name: string;
  platform_type: string;
  rules_version: string;
  rulebook_hash: string;
  updated_at: number;
}

export function FirmsAdminPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "firms"],
    queryFn: () => api.get<{ firms: FirmRow[] }>("/api/firms"),
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Firms</h1>
      <div className="pfh-card overflow-x-auto">
        {isLoading ? (
          <div className="text-muted-foreground">loading…</div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="pfh-heading text-left">
                <th className="py-2">Slug</th>
                <th>Name</th>
                <th>Platform</th>
                <th>Version</th>
                <th>Hash</th>
                <th>Updated</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="font-mono">
              {data?.firms.map((f) => (
                <tr key={f.id} className="border-t border-border/60">
                  <td className="py-2">{f.id}</td>
                  <td className="font-sans">{f.name}</td>
                  <td>{f.platform_type}</td>
                  <td>{f.rules_version}</td>
                  <td className="text-xs text-muted-foreground">{f.rulebook_hash.slice(0, 10)}…</td>
                  <td className="text-xs text-muted-foreground">
                    {new Date(f.updated_at).toLocaleDateString()}
                  </td>
                  <td>
                    {/* TODO: wire to POST /api/firms/:id/rescrape once the endpoint exists */}
                    <button
                      type="button"
                      disabled
                      aria-disabled="true"
                      title="Not yet implemented"
                      className="rounded-md border border-border px-2 py-1 text-xs text-muted-foreground opacity-50 cursor-not-allowed"
                    >
                      re-scrape
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
